'use client'

import * as React from 'react'
import { IconSearch, IconClose } from '@repo/design-system-cf/components/icons'
import { tw } from 'utils/classnames'
import { Button } from '@repo/design-system-cf/components/button'

interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string
  onChange: (value: string) => void
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  className,
  ...props
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null)

  const handleClear = () => {
    onChange('')
    inputRef.current?.focus()
  }

  return (
    <div
      className={tw(
        'flex items-center gap-2 rounded-2 border border-[#1313151F] hover:border-[#13131533] bg-white px-3 py-2 relative',
        'focus-within:ring-cf-blue-600 focus-within:ring-offset-1',
        className,
      )}
    >
      <IconSearch className="text-cf-grey-600 shrink-0 !size-4" />
      <input
        data-testid="search-input"
        ref={inputRef}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
          }
          props.onKeyDown?.(e)
        }}
        className="flex-1 bg-transparent outline-none text-cf-grey-900"
        {...props}
      />

      {value ? (
        <Button
          type="button"
          variant="ghost"
          onClick={handleClear}
          className="bg-transparent rounded-2 absolute size-4 top-1.5 right-2 flex items-center justify-center z-30"
          aria-label="Clear search"
          size="small"
          iconRight={<IconClose className="text-cf-purple-900" />}
        />
      ) : null}
    </div>
  )
}
